<!-- eslint-disable no-console -->
<template>
  <FormContainer :type="2" :title="title">
    <div class="title title-1">AILD-未来创意设计提交的初赛作品</div>
    <div class="title title-2">晋级复赛</div>
    <div class="title title-3">
      <div style="color: red; font-weight: bold;">复赛比赛时间：{{ info.nextTime }}</div>
      <div class="title title-4">
        <div v-for="i in info.group" :key="i">{{ i }}</div>
      </div>
      请于 <span class="focus">{{ info.prepareTime }}</span> 前，根据官网提示完成 <span class="focus">考前环境测试</span>， <br />
      预祝选手取得好成绩！
    </div>
  </FormContainer>
</template>
<script>
import FormContainer from './form-container.vue'
export default {
  components: {
    FormContainer
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>
<style lang="less" scoped>
.title {
  text-align: center;
  width: 789px;
  margin: 0 auto;

  &-1 {
    color: rgba(14, 30, 80, 0.3);
    font-size: 16px;
    margin-top: 76px;
  }

  &-2 {
    margin-top: 18px;
    color: rgba(3, 145, 43, 1);
    font-size: 36px;
    font-weight: 500;
  }

  &-3 {
    color: rgba(14, 30, 80, 0.5);
    font-size: 17px;
    line-height: 34px;
    font-weight: 400;
    margin-top: 60px;
  }
  &-4 {
    color: orange;
    font-weight: bold;
  }
  .focus {
    color: red;
    font-weight: 600;
  }
  .warning {
    color: #8516DD;
    font-weight: 600;
  }
}
</style>